import { render, staticRenderFns } from "./load.vue?vue&type=template&id=a3ba76aa&"
import script from "./load.vue?vue&type=script&lang=js&"
export * from "./load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports